import "./Books.module.css";
import Header from "@/reusable_sections/Header";
import ServicesGrid from "./sections/ServicesGrid";
import Footer from "@/reusable_sections/Footer";
export default function BooksPage() {
  return <div>
      <Header />
      <ServicesGrid />
      <Footer />
    </div>;
}